import React, { FC, ReactNode } from "react";
import {
  ItemContainer,
  ItemContentBody,
  LayoutWrapper,
  MainContent,
} from "../styles";
import ItemHeader from "./ItemHeader";
import {
  FlexContainer,
  IStyleProps,
  RedButton,
  SapphireBlueButton,
} from "@mindmemobile/mm-shared-global";
import styled from "styled-components";

type ILayoutProps = {
  children: ReactNode;
  headerCaption: string;
  headerComponent: React.ReactNode;
  cancelButtonCaption?: string;
  nextButtonCaption?: string;
  cancelClick: () => void;
  nextClick: () => void;
  showBackButton?: boolean;
  backClick?: () => void;
  showNextButton: boolean;
  sideBarComponent: React.ReactNode;
  showFooter?: boolean;
  showHeader?: boolean;
  noScroll?: boolean;
  isFromCheckout?: boolean;
  padding?: string;
  footerPadding?: string;
  isFooterFromCheckout?: boolean;
  showSaveAndExit?: boolean;
  saveAndExitClick?: () => void;
  disableSaveAndExit?: boolean;
  showCancelButton?: boolean;
};

const FooterContainer = styled.div<IStyleProps>`
  &.footer-checkout {
    width: 40% !important;
  }
  @media (min-width: 1600px) and (max-width: 1900px) {
    &.footer-checkout {
      width: 50%;
    }
  }
  @media (min-width: 1901px) and (max-width: 2400px) {
    &.footer-checkout {
      width: 40%;
    }
  }
  @media (min-width: 2401px) {
    &.footer-checkout {
      width: 30%;
    }
  }
`;

const Layout: FC<ILayoutProps> = ({
  children,
  headerCaption,
  headerComponent,
  cancelButtonCaption,
  nextButtonCaption,
  showBackButton,
  cancelClick,
  nextClick,
  backClick,
  showNextButton,
  sideBarComponent,
  showFooter = true,
  showHeader,
  noScroll = false,
  padding,
  isFromCheckout = false,
  showSaveAndExit = false,
  saveAndExitClick,
  disableSaveAndExit = false,
  showCancelButton = true,
  footerPadding,
}) => {
  return (
    <LayoutWrapper>
      <div>{headerComponent}</div>
      <div className="flex-auto-grow">
        <MainContent>
          {sideBarComponent}
          <div className="flex-auto-grow">
            <ItemContainer
              footer={showFooter}
              padding={padding || "30px 0px 30px 50px"}
            >
              {showHeader && (
                <ItemHeader header={headerCaption} showCopyButton={true} />
              )}
              <ItemContentBody noScroll={noScroll}>
                <div>
                  <FlexContainer fxLayout="column" className="main-panel">
                    <div className="flex-auto-grow">{children}</div>
                    {showFooter && (
                      <FooterContainer
                        className={`layout-footer ${isFromCheckout ? "footer-checkout" : ""}`}
                      >
                        <FlexContainer
                          alignItems="center"
                          justifyContent="center"
                          spacing={15}
                          size={0}
                          padding={footerPadding}
                          // padding={
                          //   isFooterFromCheckout ? "25px 0px 35px" : "20px 0px"
                          // }
                        >
                          {showCancelButton && (
                            <RedButton
                              onClick={() => cancelClick()}
                              height="40px"
                            >
                              {cancelButtonCaption || "Cancel"}
                            </RedButton>
                          )}
                          {showBackButton && (
                            <SapphireBlueButton
                              onClick={() => backClick && backClick()}
                              height="40px"
                            >
                              {"Back"}
                            </SapphireBlueButton>
                          )}

                          {showSaveAndExit && (
                            <SapphireBlueButton
                              primary
                              onClick={() =>
                                !disableSaveAndExit &&
                                saveAndExitClick &&
                                saveAndExitClick()
                              }
                              height="40px"
                              style={{
                                cursor: disableSaveAndExit
                                  ? "not-allowed"
                                  : "pointer",
                                opacity: disableSaveAndExit ? 0.6 : 1,
                              }}
                            >
                              {"Save & Exit"}
                            </SapphireBlueButton>
                          )}
                          {showNextButton && (
                            <SapphireBlueButton
                              onClick={() => nextClick()}
                              height="40px"
                            >
                              {nextButtonCaption || "Next"}
                            </SapphireBlueButton>
                          )}
                        </FlexContainer>
                      </FooterContainer>
                    )}
                  </FlexContainer>
                </div>
              </ItemContentBody>
            </ItemContainer>
          </div>
        </MainContent>
      </div>
    </LayoutWrapper>
  );
};

export default Layout;
